var map = {
	"./ABCs of the SIS/Glossary.md": 91220,
	"./Academics/Reports/Report Data.md": 42762,
	"./Academics/Reports/Report EMAs or Other.md": 43584,
	"./Academics/Reports/Report Subjects.md": 91338,
	"./Academics/Reports/Reports.md": 97258,
	"./Academics/Reports/Students.md": 88989,
	"./Academics/Reports/Subjects.md": 63898,
	"./Academics/Subjects/Subjects.md": 20457,
	"./Admin/Campus/Academics.md": 51575,
	"./Admin/Campus/Campus Information.md": 27662,
	"./Admin/Campus/Help Desk.md": 44259,
	"./Admin/Campus/Notifications.md": 85882,
	"./Admin/Campus/Packages.md": 98620,
	"./Admin/Campus/Services.md": 89013,
	"./Admin/Campus/Sports Houses.md": 90629,
	"./Admin/Campus/Terms.md": 72154,
	"./Admin/Global/Admissions.md": 70142,
	"./Admin/Global/Leave.md": 19036,
	"./Admin/Global/Programmes.md": 11141,
	"./Admin/Global/Report Templates.md": 74630,
	"./Admin/Global/Settings.md": 66354,
	"./Attendances/Attendances.md": 70459,
	"./Dashboard/Applications.md": 90687,
	"./Dashboard/Engagements.md": 58668,
	"./Dashboard/Enrolments.md": 54449,
	"./Home/Calendar - Events(OLD).md": 57321,
	"./Home/Home.md": 20803,
	"./Human Resources/Incidents.md": 87538,
	"./Human Resources/Leave Requests.md": 84248,
	"./Info Hub.md": 9245,
	"./My HomeClasses/My HomeClasses.md": 34790,
	"./Operations/Activities.md": 17469,
	"./Operations/Announcements.md": 91737,
	"./Operations/Exports.md": 68048,
	"./Operations/Helpdesk.md": 81470,
	"./Operations/Meetings.md": 32733,
	"./Operations/Roles.md": 21954,
	"./Students/Applications.md": 60044,
	"./Students/Enrolments.md": 55243,
	"./Users/Covid Assessments(OLD).md": 37975,
	"./Users/Guardians.md": 73755,
	"./Users/Import Users.md": 64790,
	"./Users/Meetings(OLD).md": 1510,
	"./Users/Profile(OLD).md": 55842,
	"./Users/Staff.md": 85538,
	"./Users/Students.md": 631,
	"./Users/User Details(OLD).md": 22769,
	"./Users/User Invites.md": 15925,
	"./Users/Users(OLD).md": 28819,
	"./Users/Wards(OLD).md": 7054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13913;